/**
 * User identification shortcuts.
 */
import { Identify } from "../../features/analytics/identify";

export class IdentifyTracker {
  constructor(public readonly client: Identify) {}

  /** Identify a user with traits. */
  user(userId: string, traits?: Record<string, unknown>, anonymousId?: string) {
    return this.client.user({ userId, anonymousId, traits: traits });
  }

  /** Update traits on an existing user. */
  updateTraits(userId: string, traits: Record<string, unknown>) {
    return this.client.updateTraits(userId, traits);
  }

  /** Alias an anonymous ID to a known user ID. */
  alias(previousId: string, userId: string) {
    return this.client.alias({ previousId, userId });
  }

  /** Associate a user with a group/company. */
  group(userId: string, groupId: string, traits?: Record<string, unknown>) {
    return this.client.group({ userId, groupId, traits: traits });
  }

  /** Reset a user's identity (logout). */
  reset(userId: string) {
    return this.client.reset(userId);
  }
}
